import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_297: DocMigration = {
  maxSchemaVersion: "0.0.297",
  description: "useBuiltinLayout from static room layout to room.",
  apply(json: any): any {
    if (json.staticRoomLayouts) {
      for (const roomId in json.staticRoomLayouts) {
        const roomLayout = json.staticRoomLayouts[roomId];
        if (!roomLayout) {
          continue;
        }

        //oddly an undefined useBuiltinLayout is treated as true
        let useBuiltinLayout = true;
        if (roomLayout.useBuiltinLayout === undefined) {
          useBuiltinLayout = true;
        } else {
          useBuiltinLayout = roomLayout.useBuiltinLayout;
        }

        // delete useBuiltinLayout even if there isn't a matching room (this shouldn't occur but could)
        delete roomLayout.useBuiltinLayout;

        if (!json.rooms) {
          continue;
        }

        const room = json.rooms[roomId];
        if (!room) {
          continue;
        }
        room.useBuiltinLayout = useBuiltinLayout;
        json.rooms[roomId] = room;
      }
    }

    if (json.rooms) {
      for (const roomId in json.rooms) {
        const room = json.rooms[roomId];
        if (room.useBuiltinLayout === undefined) {
          room.useBuiltinLayout = true;
        }
        json.rooms[roomId] = room;
      }
    }

    return json;
  },
};

export default migration_0_0_297;
